export const DELETE_FILE_LOADING = 'DELETE_FILE_LOADING'
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS'
export const DELETE_FILE_FAILED = 'DELETE_FILE_FAILED'